module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/notokr-regular.woff
// module id = qHWZ
// module chunks = 0